import { render, staticRenderFns } from "./VxCellBotLastActiveTime.vue?vue&type=template&id=5850b544&"
import script from "./VxCellBotLastActiveTime.vue?vue&type=script&lang=js&"
export * from "./VxCellBotLastActiveTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports